export default __webpack_public_path__ + "static/media/lane_coefficient_image.64d40b0f.png";